// Autogenerated file
import HeaderControls from './HeaderControls.json';

export default {
  ...HeaderControls,
};
